import { Button, notification } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { getPageHeader, updatePageHeader } from "apis/pageHeader";
import React, { useCallback, useEffect, useState } from "react";
import { Editor } from '@tinymce/tinymce-react';

export const PageHeaders: React.FC<IResourceComponentsProps> = () => {
  const listPages = [
    "home",
    "release",
    "playlist",
    "label",
    "chart",
    "contributor",
    "track",
    "subscription",
    "contactUs",
    "myLibrary",
    "contributorAdmin",
    'adCenter'
  ];
  const [editorState, setEditorState] = useState<any>({
    track: "",
    release: "",
    playlist: "",
    label: "",
    contributor: "",
    subscription: "",
    home: "",
    chart: "",
    contactUs: "",
    myLibrary: "",
    contributorAdmin: "",
    adCenter: ""
  });
  const [isUpdating, setIsUpdating] = useState<{ [key: string]: boolean }>({});

  const onEditorStateChange = useCallback((content: string, key: string) => {
    setEditorState((pre: any) => ({
      ...pre,
      [key]: content,
    }));
  }, []);

  const handleData = useCallback(async () => {
    const data = await getPageHeader();
    if (data) {
      setEditorState({
        track: data?.track,
        release: data?.release,
        playlist: data?.playlist,
        label: data?.label,
        contributor: data?.contributor,
        subscription: data?.subscription,
        home: data?.home,
        chart: data?.chart,
        contactUs: data?.contactUs,
        contributorAdmin: data?.contributorAdmin,
        myLibrary: data?.myLibrary,
        adCenter: data?.adCenter,
      });
    }
  }, []);

  useEffect(() => {
    handleData();
  }, [handleData]);

  const onSave = async (page: string) => {
    setIsUpdating((prev) => ({ ...prev, [page]: true }));
    const res = await updatePageHeader({
      [page]: editorState[page]
    });
    if (res) {
      notification.open({
        type: "success",
        message: "Notification",
        description: `${page} page saved successfully`,
      });
    } else {
      notification.open({
        type: "error",
        message: "Notification",
        description: `Error saving ${page} page`,
      });
    }
    setIsUpdating((prev) => ({ ...prev, [page]: false }));
  };

  const editorConfig = {
    height: 400,
    menubar: false,
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
    ],
    toolbar: [
      'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink anchor | image media table |',
      'forecolor backcolor | fontselect fontsizeselect | styleselect | ltr rtl | charmap emoticons | insertdatetime |',
      'searchreplace visualblocks visualchars code preview fullscreen | help'
    ].join(' '),
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px; line-height:1.6; color:#333; }'
  };

  return (
    <div
      style={{
        marginBottom: "15px",
        background: "#FFFFFF",
        padding: "30px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
      }}
    >
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "30px"
      }}>
        <h2 style={{
          fontSize: "24px",
          fontWeight: "600",
          color: "#333",
          margin: 0
        }}>
          Page Headers Management
        </h2>
      </div>
      {listPages.map((page) => (
        <div key={page} style={{ marginBottom: "40px" }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px"
          }}>
            <h5 style={{
              fontSize: "18px",
              textTransform: "uppercase",
              fontWeight: "600",
              color: "#444",
              margin: 0,
              paddingBottom: "10px",
              borderBottom: "2px solid #67be23"
            }}>
              {page === "contributorAdmin" ? "Contributor Admin" : page} Page
            </h5>
            <Button
              loading={isUpdating[page]}
              disabled={isUpdating[page]}
              style={{
                backgroundColor: "#67be23",
                color: "#fff",
                borderColor: "#67be23",
                padding: "0 24px",
                height: "36px",
                fontSize: "14px",
                fontWeight: "500"
              }}
              onClick={() => onSave(page)}
            >
              Save {page === "contributorAdmin" ? "Contributor Admin" : page} Page
            </Button>
          </div>
          <Editor
            apiKey='gg8ll8lsa9ijslpi4sg1i1u4ixnqttv1hcpak8gxp9dbjl8x'
            value={editorState[page]}
            onEditorChange={(content: string) => onEditorStateChange(content, page)}
            init={editorConfig}
          />
        </div>
      ))}
    </div>
  );
};
